import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterEvent } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    private menuStateObserver: Subject<boolean> = new Subject<boolean>();
    private menuState: Observable<boolean> = this.menuStateObserver.asObservable();

    private navigationObserver: Subject<void> = new Subject<void>();
    private navigation: Observable<void> = this.navigationObserver.asObservable();

    private path: string;

    constructor(
        private location: Location,
        private router: Router,
    ) {
        this.router.events.subscribe(event => {
            if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                const path: string = this.location.path();

                if (path !== this.path) {
                    this.path = path;
                    this.navigationObserver.next();
                }
            }
        });
    }

    /**
     * Closes navigation sidebar.
     */
    closeMenu(): void {
        this.menuStateObserver.next(false);
    }

    /**
     * Checks if navigation app is active.
     * @param app App URL slug.
     */
    isAppRoute(app: string): boolean {
        return this.path.indexOf(`/${app}/`) === 0;
    }

    /**
     * Navigation sidebar state change (open/closed) event.
     */
    onMenuState(): Observable<boolean> {
        return this.menuState;
    }

    /**
     * Navigation event.
     */
    onNavigation(): Observable<void> {
        return this.navigation;
    }

    /**
     * Opens navigation sidebar.
     */
    openMenu(): void {
        this.menuStateObserver.next(true);
    }
}
